import {BaseEntity} from '../../app-common/data/BaseEntity';

export class Customer extends BaseEntity<number> {
  isLead: boolean;
  contactName: string;
  companyName: string;
  email: string;
  phoneNumber: string;
  address1: string;
  address2: string;
  city: string;
  zip: string;
  state: string;
  county: string;
  email2: string;
  email3: string;
  dba1: string;
  entityType: string;
  ein: string;
  notes: string;
  phoneNumberType: string;
  businessPhoneNumber: string;
  altPhoneNumber: string;
  altPhoneNumberType: string;


  static getFullName(customer: Customer){
    if (!customer.companyName){
      return customer.contactName;
    }
    return customer.companyName + ' - ' + customer.contactName ;
  }
}
